import React from 'react'

import { AppAntSwitch } from '@components'
import { useAppFormHandler } from '@hooks'


export default function IsCompanySelector() {

	const { isCompany, onIsCompanyChange } = useAppFormHandler('isCompany')

	return <AppAntSwitch
		falseText="User"
		trueText="Company"
		checked={!!isCompany}
		onChange={e => {
			onIsCompanyChange(e.target.checked)
		}}
	/>

}